import React, { useState, useEffect } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import setting from "../../images/setting.svg";
import velocity from "../../images/velocity.svg";
import rocket from "../../images/rocket.svg";
import training from "../../images/training.svg";
import education from "../../images/education.svg";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";

export const AthleteTools = () => {
  const { athlete } = useAthleteAuthContext();
  const [testResult, setTestResult] = useState(null);

  const fetchTestResults = async () => {
    try {
      const response = await fetch(
        API_URL.GET_ATHLETE_RUNROCKET_TEST_RESULT + athlete.id,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch test results");
      }

      const data = await response.json();
      setTestResult(data);
      console.log(data);
    } catch (error) {
      console.log(error.message);
    }
  };

  // Fetch athlete's RunRocket test results on component mount
  useEffect(() => {
    fetchTestResults();
  }, [athlete.token]);

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col">
        <div className="flex-1 overflow-y-auto bg-white">
          <div className="bg-black py-7 xs:py-10">
            <div className="w-full max-w-2xl mx-auto px-5">
              <p className="text-white uppercase text-xl xs:text-2xl">shop</p>
            </div>
          </div>
          <div className="w-full max-w-2xl mx-auto">
            <div className="">
              <Link to="/athlete/membership">
                <button
                  className={`px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all`}
                >
                  Memberships
                </button>
              </Link>
              <Link to="/athlete/speed-products">
                <button
                  className={`px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all`}
                >
                  My Speed Products
                </button>
              </Link>

              <Link to="/athlete/strength-products">
                <button
                  className={`px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all`}
                >
                  My Strength Products
                </button>
              </Link>

              <Link to="/athlete/purchase/static-speed-templates">
                <button
                  className={`px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all`}
                >
                  Training Products
                </button>
              </Link>

              {/*testResult?.data.rsquared && testResult.data.rsquared >= 95 ? (
                <Link to="/athlete/tools/runrocket/test/result">
                  <button
                    className={`px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all`}
                  >
                   AST Speed Profile™
                  </button>
                </Link>
              ) : (
                <Link to="/athlete/tools/runrocket/test/step1">
                  <button
                    className={`px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all`}
                  >
                    AST Speed Profile™
                  </button>
                </Link>
              )*/}

              {/* 
                Existing direct-access logic has been temporarily disabled.
                Access will now be controlled from the purchase/details page
                based on whether the athlete has purchased or been assigned
                the AST Speed Profile tool.
              */}

                <Link to="/athlete/purchase-astspeedprofile-tool">
                  <button
                    className="px-5 py-5 w-full flex flex-row gap-4 border-b-2 border-darkYellow text-black text-lg xs:text-xl group hover:bg-black/5 transition-all"
                  >
                    AST Speed Profile™
                  </button>
                </Link>
            </div>
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};
